import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { ProposalProduct } from "../types/proposal";
import { formatCurrency } from "../utils/currency";

type Props = {
  products: ProposalProduct[];
  onToggle: (productId: string) => void;
  onQuantityChange: (productId: string, quantity: number) => void;
};

const ProductsCard: React.FC<Props> = ({
  products,
  onToggle,
  onQuantityChange,
}) => (
  <Card>
    <CardHeader
      title="Produtos"
      subheader="Selecione os itens e informe as quantidades"
    />
    <CardContent sx={{ pt: 0 }}>
      {products.map((product, index) => (
        <React.Fragment key={product.id}>
          {index > 0 && <Divider />}
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "stretch", sm: "center" }}
            gap={2}
            sx={{ py: 2 }}
          >
            <Stack direction="row" alignItems="flex-start" sx={{ flex: 1 }}>
              <Checkbox
                checked={product.selected}
                onChange={() => onToggle(product.id)}
                inputProps={{ "aria-label": `Selecionar ${product.name}` }}
                color="success"
              />
              <div>
                <Typography variant="subtitle1" fontWeight={600}>
                  {product.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {product.description}
                </Typography>
                <Typography variant="body2" color="primary" sx={{ mt: 0.5 }}>
                  {formatCurrency(product.unitPrice)} por unidade
                </Typography>
              </div>
            </Stack>

            <TextField
              label="Quantidade"
              type="number"
              size="small"
              value={product.quantity}
              disabled={!product.selected}
              onChange={event =>
                onQuantityChange(product.id, Number(event.target.value))
              }
              inputProps={{ min: 1, step: 1 }}
              sx={{ width: { xs: "100%", sm: 125 } }}
            />

            <div style={{ minWidth: 135 }}>
              <Typography variant="caption" color="text.secondary">
                Subtotal
              </Typography>
              <Typography variant="subtitle1" fontWeight={700}>
                {formatCurrency(product.subtotal)}
              </Typography>
            </div>
          </Stack>
        </React.Fragment>
      ))}
    </CardContent>
  </Card>
);

export default ProductsCard;
